export function capitalCase(str: string) {
  return str
    .split(/\s|_/)
    .map((word) => {
      if (word.length > 1) {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      }

      return word;
    })
    .join(' ');
}
